export default "__VITE_ASSET__5HaFRR60__"